import { render, staticRenderFns } from "./activityRuleBox.vue?vue&type=template&id=704e4d5d"
import script from "./activityRuleBox.vue?vue&type=script&lang=js"
export * from "./activityRuleBox.vue?vue&type=script&lang=js"
import style0 from "./activityRuleBox.vue?vue&type=style&index=0&id=704e4d5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports